/* eslint-disable no-constant-condition */
/* eslint-disable no-prototype-builtins */
var XPortal = XPortal || {};
XPortal.GridInlineEditing = (function () {
    var self = {
        ValueSeparator: "_#_",
        _editorsCache: {},
        _columnValidatorsCache: {},
        SaveIntervalMs: 1000,
        ActiveCellSelector: null,
        editMode: "grid-detail",
        _lastRowUid: null,
        _isInChangeEditProcess: false,
        _fixedRowHeight: "",
        Messages: {},
        GetEditMode: function (grid) {
            var gridMode = grid.getKendoGrid().options.editable;
            var editModeType = gridMode ? "grid-inline" : "grid-detail";
            return editModeType;
        },
        SaveEmAll: function (grid, button, command, options) {
            const d = $.Deferred();
            XPortal.GridInlineEditing._isInChangeEditProcess = true;
            XPortal.Loader.show({ selector: button });
            const mainLogic = function () {
                grid.parent().find("a.di-content.action:not(.inactive)").addClass("inactive").addClass("disabled");

                try {
                    if (options) grid.getKendoGrid().setOptions(options);
                }
                catch (e) {
                    if (console) console.warn(e);
                }

                XPortal.GridInlineEditing._isInChangeEditProcess = false;
                XPortal.Loader.hide({ selector: button });
                grid.parent().find("a.di-content.action.inactive.disabled").removeClass("inactive").removeClass("disabled");
                if (options) applyEditModeState(grid, button, command, options);
                return d.resolve();
            };
            XPortal.Store.SaveStoreItemsDefer(true).then(mainLogic, mainLogic);
            return d.promise();
        },
        SetEditMode: function (grid, mode, button) {
            var result = new $.Deferred();
            if (!grid || !grid.getKendoGrid) return result.reject();
            const gridInfo = XPortal.Grid.GetGridInfo(grid);
            const kgrid = gridInfo.kgrid;
            var command = kgrid.options.commands.editmode;
            var editable = mode === "grid-inline" ? true : false;
            const wasEditable = !!kgrid.options.editable;

            kgrid.options.editable = editable;
            if (editable)
                XPortal.GridInlineEditing._editorsLoader = XPortal.GridInlineEditing.GetEditors({
                    columns: kgrid.options.columns, url: kgrid.options.inlineEditorsLoadUrl, nodeId: kgrid.options.pageData.nodeId
                });
            var options = { editable: editable, batch: editable };
            kgrid.unbind("parent.changed.fixLayoutFunc");
            const fixLayoutFunc = function (e) {
                XPortal.GridInlineEditing.FixLayout(e)
            };
            kgrid.bind("parent.changed.fixLayoutFunc", fixLayoutFunc);

            var nodeId = kgrid.options.pageData.nodeId;
            if (!editable) {
                const actionCommand = command;
                if (wasEditable) self.SaveEmAll(grid, button, actionCommand, options);
                self.ChangeEditGridClass(editable, grid);
                command = command ? command : {};
                var title = editable ? command.disableTitle : command.enableTitle;
                $(button).attr("title", title);
                $(button).append(XPortal.GridInlineEditing.WrapTitle(title));
                if (!wasEditable) applyEditModeState(grid, button, actionCommand, options);
                return result.resolve();
            }
            else {
                if (XPortal.GridInlineEditing._editorsLoader) {
                    XPortal.GridInlineEditing._editorsLoader.then(function () {
                        delete XPortal.GridInlineEditing._editorsLoader;
                        kgrid.setOptions(options);
                        self.ChangeEditGridClass(editable, grid, kgrid);
                        return result.resolve();
                    });
                } else {
                    kgrid.setOptions(options);
                    self.ChangeEditGridClass(editable, grid, kgrid);
                    result.resolve();
                }
                XPortal.GridActions.actionmodels[nodeId].set("inlinedisabled", !editable);
                self.ChangeActionView(button, command, editable);
                return result;
            }
        },
        ChangeEditGridClass: function (editable, grid, kgrid) {
            if (editable) {
                self.bindSellHoverIcon.init(grid);
                grid.addClass('grid-in-edit-mode');
            } else {
                grid.off('.editableicon');
                grid.removeClass('grid-in-edit-mode');
            }
        },
        ChangeActionView: function (button, command, editable) {
            $(button).html('');
            command = command ? command : {};
            let title = editable ? command.disableTitle : command.enableTitle;
            $(button).append(editable ? command.disableIcon : command.enableIcon);
            $(button).attr("title", title);
            $(button).append(XPortal.GridInlineEditing.WrapTitle(title));
        },
        WrapTitle: function (title) {
            return "<span class='dm-item-text'>" + title + "</span>";
        },
        Init: function (gridInfo, settings, modelPath) {
            const grid = gridInfo.grid;
            settings.editable = false;

            var inlineeditingenabled = settings.columns.find(function (value) { return value.canedit || value.cancreate; }) != null;
            var editModeCommand = settings.commands ? settings.commands.editmode : null;
            var editModeCommandHidden = editModeCommand != null ? editModeCommand.isEnabledByDefault && editModeCommand.hideFromToolbar : false;

            const parentModelName = XPortal.Store.GetParentModelName(gridInfo.modelName, modelPath);
            const parentModel = (XPortal.Store.GetModelByName(parentModelName) || {}).model || {};
            const isViewWithInheritance = parentModel.isViewMode && parentModel.isViewModeInheritedOnChild;
            if (isViewWithInheritance) inlineeditingenabled = false;

            if (inlineeditingenabled) {
                XPortal.GridInlineEditing._editorsLoader = XPortal.GridInlineEditing.GetEditors({
                    columns: settings.columns,
                    url: settings.inlineEditorsLoadUrl,
                    nodeId: settings.pageData.nodeId
                });
                $.when(XPortal.GridInlineEditing._editorsLoader).then(function () {
                    delete XPortal.GridInlineEditing._editorsLoader;
                });
            }
            if (grid.closest(".detail-page").length) {//hide edit mode for childgrid
                let isEnabledByDefault = inlineeditingenabled;
                if (editModeCommand != null && !editModeCommand.isEnabledByDefault) isEnabledByDefault = false;
                if (XPortal.Account.Name) {
                    if (isEnabledByDefault) settings.editable = true;
                }
                var editModeButtons = gridInfo.actionsHeader.find("[data-action=EditMode]");
                if (isViewWithInheritance || editModeCommandHidden) {
                    if (editModeCommand) delete settings.commands.editmode;
                    editModeButtons.remove();
                }
                if (isEnabledByDefault) {
                    self.bindSellHoverIcon.init(grid);
                    gridInfo.grid.addClass('grid-in-edit-mode');
                } else
                    gridInfo.grid.removeClass('grid-in-edit-mode');

                if (editModeCommand && isEnabledByDefault)
                    self.ChangeActionView(editModeButtons, editModeCommand, isEnabledByDefault);
            }

            if ('ontouchstart' in document.documentElement) {
                gridInfo.grid.on('touchstart', 'td', function (e) {
                    var cellId = self.EnsureGridInfo(gridInfo).kgrid._cellId;
                    $('.' + cellId, gridInfo.grid).removeClass(cellId);
                    $(this).addClass(cellId);
                });
                self.ActiveCellSelector = function (grid) {
                    return '.' + self.EnsureGridInfo(gridInfo).kgrid._cellId;
                };
            }
            else
                self.ActiveCellSelector = function (grid) {
                    return '#' + self.EnsureGridInfo(gridInfo).kgrid._cellId;
                };

            settings.selectable = true;
            if (inlineeditingenabled) {
                settings.columns.forEach(function (c) {
                    var pageSettings = {
                        nodeId: settings.pageData.nodeId,
                        url: settings.inlineEditorsLoadUrl,
                        grid: grid
                    };
                    c.editor = XPortal.GridInlineEditing.GetEditor.bind(pageSettings);
                    c.editable = XPortal.GridInlineEditing.IsColumnEditable.bind({
                        grid: pageSettings.grid,
                        column: c,
                        editable: c.canedit,
                        creatable: c.cancreate
                    });

                    c.attributes = c.attributes || {};
                    c.attributes.class = (c.attributes.class ? c.attributes.class + " " : "") + (c.canedit ? "cell-editable" : "cell-readonly");

                });
                settings.beforeEdit = function (e) {
                    var $cell = $(self.ActiveCellSelector(e.sender.element), e.sender.element);
                    if ($cell.length === 0) return;

                    if ($(".detail-field-inline", e.sender.element).length > 0) { //workaround with kendo bug (cell close is not fired)
                        //will close or edit fields
                        $(".detail-field-inline", e.sender.element).remove();
                    }

                    XPortal.GridInlineEditing.ClearEndEditGridRefresh(e);

                    XPortal.GridInlineEditing.FixLayout(e);
                };
                settings.navigatable = true;
                settings.cellClose = XPortal.GridInlineEditing.ProcessEndEditEvent;
                // handle clicks outside the grid to close any open editors (Kendo doesn't do this by default)
                $(document)
                    .off("mousedown.xpandgridcelloutside")
                    .on("mousedown.xpandgridcelloutside", XPortal.GridInlineEditing.CloseEditorsOnOutsideClick);
                window.onbeforeunload = function (e) {
                    $.when(XPortal.GridInlineEditing.SaveInlineEditorsBeforePageLeave()).done(function () {
                        window.onbeforeunload = null;
                        return null;
                    });
                };
            }
        },
        EnsureGridInfo: function (gridInfo) {
            XPortal.Grid.GetGridInfo(gridInfo.grid, gridInfo);
            return gridInfo;
        },
        bindSellHoverIcon: {
            init: function (grid) {
                if (!XPortal.Utils.isTouchDevice()) {
                    grid.on('mouseenter.editableicon', 'tr', function () {
                        self.bindSellHoverIcon.showPencil(grid, this);
                    }).on('mouseleave.editableicon', 'tr', function () {
                        self.bindSellHoverIcon.hidePencil();
                    });
                } else {
                    grid.on('touchend.editableicon', 'tr', function (e) {
                        self.bindSellHoverIcon.hidePencil();
                        self.bindSellHoverIcon.showPencil(grid, this);
                    });
                }
            },
            showPencil: function (grid, trItem) {
                const ginfo = XPortal.Grid.GetGridInfo(grid);
                const grMdl = XPortal.Store.GetModelByName(ginfo.modelName);
                const prMdl = (XPortal.Store.GetParentModel(grMdl) || {}).model || {};

                if (prMdl.isViewMode && prMdl.isViewModeInheritedOnChild) return;
                const cellsInSettings = ginfo.kgrid.options.columns;
                var trItems = grid[0].querySelectorAll('[data-uid="' + trItem.getAttribute('data-uid') + '"]');
                trItems.forEach(tr => {
                    tr.querySelectorAll('td').forEach(td => {
                        if (!td.classList.contains('k-edit-cell')) {
                            var cellInSettings = cellsInSettings.filter(item => item.field === td.dataset.cfield);
                            if (cellInSettings.length && (cellInSettings[0].canedit)) {
                                td.classList.add('cell-editable-hover');
                            } else if (cellInSettings.length && cellInSettings[0].cancreate) {
                                var isNewLIne = ginfo.kgrid.dataSource.data().find(function (x) { return x.uid == $(trItem).data("uid"); })._newInlineRecord;
                                if (isNewLIne) td.classList.add('cell-editable-hover');
                            }
                        }
                    });
                });
            },
            hidePencil: function () {
                document.querySelectorAll('tr:not(.k-grid-edit-row):not(.k-state-selected) .cell-editable-hover').forEach(item => {
                    item.classList.remove('cell-editable-hover');
                });
            }
        },
        StartAutoSave: function () {
            if (!XPortal.Store.IsInlineEntityToSavePresent()) return;
            const sState = XPortal.Store.GetState();
            if (sState.editParameters && sState.editParameters.IsCreating) return;

            //validate edit form first if it was not validated 
            if (sState.editParameters) {
                var container = $("div.content.detail-page, div.content.wizard-page");
                XPortal.EditForm.ValidateTask(container, ".detail-field", true).then(function Valid() {
                    XPortal.Store.SaveInlineItemsRefresh(true, true);
                }, function NotValid() {
                    if (console) console.log("detail page not valid. autosave omitted");
                });
            }
            else if ($(".field-validation-error").length < 1) {
                XPortal.Store.SaveInlineItemsRefresh(true, true);
            }
        },
        FixLayout: function (e) {
            if (!e.sender) {
                return;
            }

            if (e.sender.element.find('.field-validation-error, .input-validation-error').length) {
                return;
            }

            var thisRowId = $('#' + e.sender._cellId + ', .' + e.sender._cellId).closest('tr').attr('data-uid');

            if (XPortal.GridInlineEditing._lastRowUid && XPortal.GridInlineEditing._lastRowUid !== thisRowId) {
                var $trItems = e.sender.element.find("tr[data-uid=" + XPortal.GridInlineEditing._lastRowUid + "]");
                $trItems.css("height", XPortal.GridInlineEditing._fixedRowHeight);
                $trItems.removeClass("k-grid-edit-row");
            }

            XPortal.GridInlineEditing._lastRowUid = thisRowId;
        },
        ClearEndEditGridRefresh: function (e) {
            if (!e.sender) return;
            clearTimeout(e.sender.endEditGridRefreshTimer);
        },
        RefreshCell: function (model, entity, fieldObj, value) {
            try {
                var cell = model.GridModel.element.find("[data-uid=\'" + entity.uid + "\']").find("[data-cfield=" + fieldObj.Name.toLowerCase() + "]");
                if (!cell || !cell.length) return;
                var column = model.GridModel.columns.find(col => col.field == fieldObj.Name.toLocaleLowerCase());
                if (column && column.template && String(column.template).indexOf("XPortal.Grid.GetTemplateValue") < 0) {
                    var tmpl = typeof column.template === "function" ? column.template : kendo.template(column.template);
                    cell.html(tmpl(entity));
                    return;
                }

                var format = "";
                if (column && column.template) {
                    format = column.template.split(",")[3].ltrim('"').rtrim('"') || "";
                    if (format) format = decodeURIComponent(format);
                }

                var tempObj = {};
                tempObj[fieldObj.Name.toLowerCase()] = value;
                var cellValue = XPortal.Grid.GetTemplateValue(tempObj, fieldObj.Type.toLowerCase(), encodeURIComponent(fieldObj.Name.toLowerCase()), encodeURIComponent(format), model.model.NodeId);
                cell.html(cellValue);
            } catch (e) {
                if (console) console.error("Can't RefreshCell(...) ", e);
            }
        },
        SaveInlineEditorsBeforePageLeave: function () {
            return XPortal.Store.SaveStoreItemsDefer(true, true, null, true);
        },
        StartSaveQueue: function (chain, continueOnFailure) {
            var handleStep, handleResult,
                steps = Array.prototype.slice.call(chain),
                def = new $.Deferred(),
                defs = [],
                results = [];
            handleStep = function () {
                if (!steps.length) return def.resolveWith(defs, [results]);
                var step = steps.shift(), result = $.isFunction(step) ? step() : step;
                handleResult(
                    $.when(result).always(function () {
                        defs.push(this);
                    }).done(function () {
                        results.push({ resolved: Array.prototype.slice.call(arguments) });
                    }).fail(function () {
                        results.push({ rejected: Array.prototype.slice.call(arguments) });
                    })
                );
            };
            handleResult = continueOnFailure
                ? function (result) {
                    result.always(handleStep);
                }
                : function (result) {
                    result.done(handleStep).fail(handleStep);
                };
            handleStep();
            return def.promise();
        },
        AddInlineRecord: function (grid, modificationCallback, dontSetCellEdit) {
            var kgrid = $(grid).data("kendoGrid");
            var gridId = kgrid.element.attr("data-id");
            var parentInfo = XPortal.Grid.dictionaryParent[gridId];
            var op = {
                url: kgrid.options.addinlineUrl.split("?")[0],
                alias: XPortal.Utils.hrefQuery(kgrid.options.addinlineUrl, "Alias"),
                nodeid: grid.attr("data-id"),
                IsCreating: true,
                parentInfo: parentInfo ? decodeURIComponent(parentInfo) : null
            };
            var result = new $.Deferred();
            XPortal.GridInlineEditing.GetNewInlineRecord(op).done(function (record) {
                if (record.State < 0) {
                    XPortal.Modal.alert({
                        headerText: kgrid.options.messages.addinline.warningtitle,
                        alertText: record.Errors ? record.Errors.join() : ""
                    });
                    return result.reject();
                }
                var preparedEntity = XPortal.Grid.MapEntity(record);
                preparedEntity.IsCreating = true;
                preparedEntity._newInlineRecord = true;
                var modelName = XPortal.Store.getGridModelName(grid.attr("id"));
                XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.BIND_ENTITY, modelName, entity: preparedEntity });
                var fecolumn = kgrid.columns.filter(col => (col && col.headerAttributes && col.attributes['data-ctype'] != "calendarcolumn" && (col.editable && col.editable(preparedEntity))));
                var xrow = kgrid.dataSource.insert(0, preparedEntity);
                if (typeof (modificationCallback) === "function") {
                    modificationCallback(record);
                } else {
                    XPortal.Store.DispatchFieldEvents(xrow, fecolumn.map(function (x) {
                        return {
                            name: x.attributes["data-cfield"],
                            type: x.attributes["data-ctype"]
                        };
                    }), modelName, false, true);
                }
                var fcolumn = fecolumn.find(col => col);
                var firstEditableColId = fcolumn && fcolumn.headerAttributes ? fcolumn.headerAttributes.id : -1;
                var editCell = $("[aria-describedby='" + firstEditableColId + "']", kgrid.element).first();
                if (!$(document.activeElement).hasClass("k-selectable")) {
                    if (editCell.parents(".k-selectable").length > 0) {
                        var targetTable = editCell.parents(".k-selectable")[0]; //.tabIndex
                        if (typeof targetTable.tabIndex === typeof undefined) {
                            targetTable.tabIndex = -1;
                        }
                        targetTable.focus();
                    }
                }

                kgrid.current(editCell);
                if (!dontSetCellEdit)
                    kgrid.editCell(editCell[0]);
                return result.resolve(xrow, modelName);
            }).fail(function (model) {
                let modalParams = [{
                    dataset: {
                        showModal: true,
                        modalTitle: grid.data("kendoGrid").options.messages.addinline.cannotcreateentity,
                        modalText: model.Errors ? model.Errors.join() : model.statusText ? model.statusText : ""
                    }
                }];
                XPortal.Modal.checkIfModal(modalParams);
                return result.reject();
            });
            return result;
        },
        GetNewInlineRecord: function (params) {
            if (!params.url)
                throw ("inline editors loading url is not defined");

            var d = $.Deferred();

            jQuery.ajax({
                method: "POST",
                headers: {
                    "RequestVerificationToken": XPortal.Main.getAntiForgeryToken()
                },
                url: XPortal.Utils.EnsureInProfile(params.url),
                data: params,
                dataType: "json",
                success: function (xdata) {
                    if (xdata) {
                        d.resolve(xdata);
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (console) console.error(params, jqXHR, textStatus, errorThrown);
                    d.reject(jqXHR);
                }
            }).fail(function (problem) { d.reject(problem); });

            return d.promise();
        },
        ProcessEndEditEvent: function (e) {
            if (console) console.log("process end edit", e.container.data().cfield);

            var field = e.container.data().cfield;
            var editorElement = XPortal.GridInlineEditing.GetCellEditorControl(e.container, field);
            if (editorElement && editorElement.length > 0) {
                editorElement.trigger("dispatchFieldEvent");
            }

            XPortal.GridInlineEditing.ProcessEndEdit({
                container: e.container,
                model: e.model,
                field: field,
                grid: e.sender,
                columns: this.columns
            });
            var tr = $(e.container).closest("tr");
            XPortal.GridInlineEditing._lastRowUid = tr.attr("data-uid");

            var modelName = XPortal.Store.GetModelByNodeId(e.sender.options.pageData.nodeId);
            XPortal.Store.ValidateGridModel(modelName, false);
        },
        CloseEditorsOnOutsideClick: function (e) {
            var $target = $(e.target);
            if ($target.closest(".k-animation-container, .k-list-container, .k-calendar-container, .k-popup, .modal, .k-window, .k-dialog, .k-overlay").length)
                return;

            $(".k-grid").has(".k-edit-cell").each(function () {
                var $grid = $(this);
                if ($target.closest($grid).length) return; // click landed inside this grid - let Kendo handle it
                var kgrid = $grid.data("kendoGrid");
                if (kgrid && typeof kgrid.closeCell === "function") {
                    var activeEl = document.activeElement;
                    var editCell = $grid.find(".k-edit-cell")[0];
                    if (activeEl && editCell && $.contains(editCell, activeEl) && typeof activeEl.blur === "function") {
                        activeEl.blur();
                    }
                    kgrid.closeCell();
                }
            });
        },
        ProcessEndEdit: function (options) {
            try {
                var fieldName = options.field;
                options.nodeId = options.grid.options.pageData.nodeId;
                XPortal.Store.AppStore.dispatch({
                    type: XPortal.Redusers.ACTIONS.END_EDIT,
                    options: {
                        field: { field: fieldName },
                        nodeId: options.nodeId,
                        model: XPortal.Store.getGridModelName(options.grid.element[0].id)
                    }
                });
            } catch (ex) {
                if (console) console.error("ProcessEndEdit error.", ex);
            }
        },
        SaveEntity: function (model, nodeId, batch) {
            var uid = model.UniqueId ? model.UniqueId : model.uniqueid;
            var kgrid = $("#entity-grid-" + nodeId).data("kendoGrid");
            var parentInfo = XPortal.Grid.dictionaryParent[nodeId] ? decodeURIComponent(XPortal.Grid.dictionaryParent[nodeId]) : null;
            if (console) console.log("Save entity. UniqueId: " + uid);
            var deferred = $.Deferred();

            var isNewInlineRecord;
            if (model._newrecord === false) isNewInlineRecord = false;
            else if (model.IsCreating) isNewInlineRecord = true;
            var fields = [];
            model.Fields.forEach(function (f) {
                if (kgrid.columns.find((c) => c.field.toLowerCase() === f.Name.toLowerCase())) {
                    fields.push({ field: f.Name, data: f.StringValue, ftype: f.Type, id: f.uid });
                }
            });
            var keys = model.Keys ? model.Keys.map(function (keyField) {
                return {
                    field: keyField.Name,
                    data: keyField.StringValue,
                    ftype: keyField.Type,
                    id: keyField.uid
                };
            }) : [];
            var modelToSave = {
                gridModel: model,
                model: {
                    Fields: fields,
                    Keys: keys,
                    EntityAlias: model.EntityAlias,
                    NodeId: nodeId,
                    UniqueId: uid,
                    isCreating: isNewInlineRecord,
                    parentInfo: parentInfo
                }
            };
            if (modelToSave.model && modelToSave.model.Fields) {
                var lengthFields = modelToSave.model.Fields.length;
                for (var index = 0; index < lengthFields; index++) {
                    var srcdata = modelToSave.model.Fields[index].data;
                    if (Array.isArray(srcdata) || _.isArray(srcdata) || (!_.isString(srcdata) && srcdata && srcdata["filter"] != null)) {
                        modelToSave.model.Fields[index].data = modelToSave.model.Fields[index].data.join(XPortal.GridInlineEditing.ValueSeparator);
                    }
                }
            }

            self.HandleSave({ url: $("#entity-grid-" + nodeId).data("save-url") }, modelToSave)
                .then(
                    data => deferred.resolve(data),
                    data => {
                        data = data || { result: null };
                        if (!batch) XPortal.EditForm.ShowErrorMessage(data.result, $("#entity-grid-" + nodeId).attr("data-save-error-header"));
                        deferred.reject(model, data.result);
                    }
                );
            return deferred.promise();
        },

        IsFailedSaveResult: function (result) {
            return !!result && (!!result.Errors || result.State < 0);
        },
        HandleSave: function (sttgs, qdata) {
            return new Promise((onOk, onErr) => {
                if (!qdata || !qdata.model) return onOk({ result: {} });
                self.DateTimeFieldProcessing(qdata.model);
                XPortal.Store.itemsInSaving++;
                console.log("start saving. items in save remain: ", XPortal.Store.itemsInSaving);

                var ajaxReq = {
                    url: XPortal.Utils.EnsureInProfile(getEntityProfileInfo(sttgs.url, qdata)), type: 'POST', dataType: 'json', data: JSON.stringify({ model: qdata.model }), cache: false,
                    headers: Object.assign({}, { "RequestVerificationToken": XPortal.Main.getAntiForgeryToken() }, sttgs.headers || {}),
                    contentType: 'application/json; charset=utf-8',
                    success: function (data) {
                        XPortal.Store.itemsInSaving--;
                        console.log("save done:" + (data.Requested || {}).UniqueId + ", items in save remain: ", XPortal.Store.itemsInSaving);
                        qdata.result = data;
                        XPortal.Store.AppStore.dispatch({
                            type: XPortal.Redusers.ACTIONS.SERVER_MESSAGES,
                            result: data.Messages,
                            selector: XPortal.Store.GetModelByNodeId(qdata.model.NodeId)
                        });
                        if (!data.Errors) return onOk(qdata);
                        return onErr(qdata);
                    },
                    error: function (xhr, status, error) {
                        XPortal.Store.itemsInSaving--;
                        console.log("save ERROR, items in save remain: ", XPortal.Store.itemsInSaving);
                        onErr(xhr, status, error);
                    },
                };
                $.ajax(ajaxReq);
            });
        },
        BindKeyboard: function (e) {
            if (e.keyCode === kendo.keys.TAB) {
                self.GoToNext($(e.currentTarget.closest('.k-grid')), false, e);
            }
            if (e.keyCode === kendo.keys.ENTER) {
                if ($(e.target).attr('aria-invalid') === 'true') {
                    return;
                }

                var $grid = $(e.currentTarget.closest('.k-grid'));
                var gridData = $grid.data('kendoGrid');
                var $current = gridData.current();
                if (!$current) return;
                if ($current.find('textarea').length && e.shiftKey) return;
                self.GoToNext($grid);
            }
            if (e.keyCode === kendo.keys.ESC) {
                var $errorItem = $('.input-validation-error');
                if ($errorItem.length && !$errorItem.is(":focus")) {
                    return;
                }

                XPortal.GridInlineEditing.RemoveRowEditAttributes($(e.currentTarget.closest('.k-grid')));
            }
        },
        GoToNext: function (grid, skipCurrentCell = true, e = null) {
            const griddata = grid.data('kendoGrid');
            const current = griddata.current();
            if (!current) return;

            let model = griddata.dataItem(current.closest('tr'));
            let creatingProcess = model.hasOwnProperty("_newInlineRecord") && !model.hasOwnProperty("_wasInlineSaved");
            let currentColumn = griddata.columns[griddata.cellIndex(current)];
            let currentCell = current;
            const shouldSkipCurrentCell = skipCurrentCell || (!currentColumn.canedit && !(creatingProcess && currentColumn.cancreate));

            if (shouldSkipCurrentCell) {
                while (true) {
                    const nextCell = griddata._tabNext(currentCell, currentCell.closest('table').get(0), e?.shiftKey || false);
                    if (nextCell.length === 0) {
                        e?.preventDefault();
                        e?.stopPropagation();
                        break;
                    }

                    const parent = nextCell.parents("tr");
                    if (parent.hasClass("k-group-footer") || parent.hasClass("k-grouping-row")) {
                        currentCell = nextCell;
                        continue;
                    }

                    currentColumn = griddata.columns[griddata.cellIndex(nextCell)];
                    model = griddata.dataItem(nextCell.closest('tr'));
                    creatingProcess = model.hasOwnProperty('_newInlineRecord') && !model.hasOwnProperty('_wasInlineSaved');
                    const changesAllowed = creatingProcess ? (currentColumn.canedit || currentColumn.cancreate) : currentColumn.canedit;

                    if (changesAllowed) {
                        griddata._handleEditing(nextCell, nextCell, nextCell.closest('table'));
                        e?.preventDefault();
                        e?.stopPropagation();
                        break;
                    }

                    currentCell = nextCell;
                }
            }
        },
        RemoveRowEditAttributes: function ($grid) {
            var rowId = $grid.find('.k-grid-edit-row:first').attr('data-uid');
            if (!$grid.find('.k-edit-cell').length) {
                $grid.find('tr[data-uid="' + rowId + '"]').removeClass('k-grid-edit-row').css('height', XPortal.GridInlineEditing._fixedRowHeight);
            }
        },
        GetEditor: function (container, options) {
            if (XPortal.GridInlineEditing._isInChangeEditProcess) return;
            var $cell = $(container);
            XPortal.GridInlineEditing._fixedRowHeight = $cell.parents("tr").css("height");
            XPortal.Loader.show({ selector: $cell, size: '3rem' });
            var modelName = XPortal.Store.getGridModelName(this.grid.attr("id"));
            let nodeId = this.grid.getKendoGrid().options.pageData.nodeId;
            var params = {
                entityAlias: options.model.EntityAlias ? options.model.EntityAlias : options.model.alias,
                url: this.url,
                fieldName: options.field,
                nodeId: nodeId
            };
            XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.BIND_ENTITY, modelName, entity: options.model });
            var kgrid = this.grid.getKendoGrid();
            try {
                var editorHtml = XPortal.GridInlineEditing.GetEditorForCell(params);
                if (editorHtml) {
                    options.grid = kgrid;
                    var editorHTML = XPortal.GridInlineEditing.FillEditorTemplate(options, editorHtml);
                    if (editorHTML !== null) {
                        container[0].innerHTML = '';
                        $(editorHTML).appendTo(container);
                        XPortal.GridInlineEditing.InitKendoEditor(container, options);
                        XPortal.GridInlineEditing.SetupEditorValidationRules(container, options, modelName);
                    }
                    XPortal.Loader.hide({ selector: $cell });
                    XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.EDITOR_LOADED, model: modelName, entity: options.model, data: { Alias: params.entityAlias, NodeId: params.nodeId } });
                }
            } catch (e) {
                if (console) console.error(e, params);
                XPortal.Loader.hide({ selector: $cell });
            }
        },
        ValidateInlineEditors: function (items, markNotValid, showValMessages) {
            var validItems = [];
            items.forEach(function (itemToValidate) {
                var modelName = XPortal.Store.GetModelByNodeId(itemToValidate.nodeId);
                var model = XPortal.Store.GetModelByName(modelName);
                var grid = model.GridModel;

                itemToValidate.entity.validationResults = itemToValidate.entity.validationResults || {};

                var isValidRow = true;
                var columnsToValidate = grid.columns.filter(c => !c.hidden && c.canedit);
                var statusValMsg = [];
                columnsToValidate.forEach(function (column) {
                    var isValidCell = true;
                    var validatorKey = grid.options.pageData.nodeId + "_" + column.field;
                    var validatorTemplate = XPortal.GridInlineEditing._columnValidatorsCache[validatorKey];
                    if (validatorTemplate) {
                        var options = { model: itemToValidate.entity, grid: model.GridModel, field: column.field };

                        var validatorHtml = XPortal.GridInlineEditing.FillEditorTemplate(options, validatorTemplate);
                        var validator = $(validatorHtml);
                        var validatorContainer = $("<form id='" + validatorKey + "'></form>");
                        validator.appendTo(validatorContainer);
                        var valErrors = [];
                        XPortal.Validation.ParseElementsIn(validatorContainer, validatorContainer, function (valRes, valControl) {
                            if (!showValMessages) return;
                            var d = $("<div></div>").append(valRes).text();
                            if (d && d.length) valErrors.push(d);
                        });
                        isValidCell = XPortal.Validation.ValidateElement(validator, validatorContainer);
                        itemToValidate.entity.validationResults[column.field] = isValidCell;
                        if (!isValidCell) statusValMsg.push({ field: column.field, error: valErrors.join("\r\n") });
                    }
                    if (markNotValid) {
                        var cell = $("tr[data-uid='" + itemToValidate.entity.uid + "'] td[data-cfield='" + column.field + "']");
                        if (cell && cell.length > 0) {
                            if (!isValidCell) {
                                cell.addClass("not-valid-cell")
                            } else {
                                cell.removeClass("not-valid-cell");
                            }
                        }
                    }
                    isValidRow = isValidRow && isValidCell;
                });
                itemToValidate.entity.validationResults.summary = "";
                delete itemToValidate.entity.validationResults.summaryDetails;//left from the previous run
                if (isValidRow) validItems.push(itemToValidate);
                else {
                    itemToValidate.inUse = false;
                    var countOfFieldsWithErrors = 0;
                    for (var key in itemToValidate.entity.validationResults) {
                        if (key === "summary" || key === "summaryDetails") continue;
                        var value = itemToValidate.entity.validationResults[key];
                        if (!value) countOfFieldsWithErrors++;
                    }
                    itemToValidate.entity.validationResults.summary = XPortal.Template.ReplaceFormatString(XPortal.Localization.GetCachedString("XFGrid.Pages.Errors.RowValidationErrors.Tooltip", ""), countOfFieldsWithErrors);
                    if (showValMessages) itemToValidate.entity.validationResults.summaryDetails = statusValMsg;
                }
            });

            return validItems;
        },
        FillEditorTemplate: function (options, editorHtml) {
            try {
                if (console) console.debug("FillEditorTemplate(...)");
                let details = options.grid && options.grid.options && options.grid.options.pageData ? options.grid.options.pageData.details : null;
                let parentInfo = details && details.parentInfo ? details.parentInfo : "";

                let uid = options.model.UniqueId ? options.model.UniqueId : options.model.uniqueid;
                if (options.model.Fields) {
                    var field = options.model.Fields.find(f => f.Name.toLowerCase() === options.field);
                    if (field && field.ismultiselect && field.StringValue && field.StringValue.join)
                        fieldValue = field.StringValue.join(XPortal.GridInlineEditing.ValueSeparator);
                    else {

                        var fieldValue = options.model[options.field];
                    }
                }

                if (editorHtml.indexOf('{boolEditValue}') > -1) {
                    if (XPortal.Grid._clickedBool) {
                        var colUid = $("#" + options.grid._cellId).attr("aria-describedby");
                        var rowUid = $("#" + options.grid._cellId).parents("tr").attr("data-uid");
                        if (XPortal.Grid._clickedBool.rowUid === rowUid && XPortal.Grid._clickedBool.colUid === colUid) {
                            if (typeof fieldValue === "undefined") fieldValue = 0;
                            fieldValue = !fieldValue;
                            fieldValue = fieldValue === true ? "1" : "0";
                            XPortal.Store.AppStore.dispatch({ type: XPortal.Redusers.ACTIONS.EDIT_FIELD, field: { field: options.field, ftype: "Boolean", data: fieldValue }, model: XPortal.Store.getGridModelName(options.grid.element[0].id) });
                            XPortal.Grid._clickedBool = null;
                        }
                    }
                    editorHtml = editorHtml.replace(/{boolEditValue}/g, fieldValue ? "checked" : "");
                }
                else if (typeof fieldValue !== "undefined" && fieldValue !== null) {
                    editorHtml = editorHtml.replace(/{editValue}/g, fieldValue);
                }
                else {
                    editorHtml = editorHtml.replace(/{editValue}/g, "");
                }
                editorHtml = editorHtml.replace(/{recordEntityAlias}/g, options.model.EntityAlias);
                editorHtml = editorHtml.replace(/{controlName}/g, options.field + "_inlineEditor");
                editorHtml = editorHtml.replace(/{recordUID}/g, uid);
                editorHtml = editorHtml.replace(/{parentInfo}/g, parentInfo);

                return editorHtml;
            }
            catch (e) {
                if (console) console.error(e);
                return null;
            }
        },
        InitKendoEditor: function (container, options) {
            try {
                const modelName = XPortal.Store.getGridModelName(options.grid.element[0].id);
                if (container.children("input.xpand-dropdown").length > 0) {
                    var fName = container.children("input.xpand-dropdown")[0].dataset.filtertype;
                    if (fName && fName.split("|").length > 1 && fName.indexOf("CurrentEntity") > -1) {
                        var linkedFields = fName.split("|")[1].split(";");
                        var modelFields = []; // will get values from linked fields and pass to Detail/GetLookupData
                        linkedFields.forEach(function (fld, i) {
                            var targetField = options.model.Fields.find(f => f.Name === fld);
                            if (targetField) {
                                var fdata = {
                                    field: targetField.Name,
                                    ftype: targetField.Type,
                                    data: targetField.StringValue
                                };
                                modelFields.push(fdata);
                            }
                        });

                    }
                }
                XPortal.Main.InitInlineControls(container, modelName, options, modelFields);

                var editor = $("input", container);
                if (editor.length === 0)
                    editor = $("textarea", container);
                if (editor.length > 0) {
                    editor[0].focus();
                    container.addClass("k-edit-cell");
                }
            }
            catch (e) {
                if (console) console.error(e);
            }
        },
        GetEditorForCell: function (params) {
            if (!params.url)
                throw "inline editors loading url is not defined";
            let ikey = params.nodeId + "_" + params.fieldName;

            const r = getInEditorByKey(ikey);
            if (r) return r;
            if (params.fieldName.length > XPortal.Grid.normalizeFieldPrefix.length) {
                const fprefix = params.fieldName.substr(0, XPortal.Grid.normalizeFieldPrefix.length).toLowerCase();
                if (fprefix == XPortal.Grid.normalizeFieldPrefix.toLowerCase()) {
                    const fname = params.fieldName.substr(XPortal.Grid.normalizeFieldPrefix.length);
                    ikey = params.nodeId + "_" + fname;
                    return getInEditorByKey(ikey);
                }
            }
            ikey = params.nodeId + "_" + XPortal.Grid.normalizeFieldPrefix + params.fieldName;
            return getInEditorByKey(ikey);
        },
        GetEditors: function (params) {
            if (!params.url)
                throw "inline editors loading url is not defined";

            var d = $.Deferred();
            var ajaxReq = jQuery.ajax({
                method: "POST", cache: false,
                headers: {
                    "RequestVerificationToken": XPortal.Main.getAntiForgeryToken()
                },
                url: XPortal.Utils.EnsureInProfile(params.url),
                data: kendo.stringify({ nodeId: params.nodeId }),
                contentType: "application/json; charset=utf-8",
                dataType: "html",
                success: function (xdata) {
                    if (xdata) {
                        var jsonData = JSON.parse(xdata);
                        if (jsonData.editors) {
                            Object.keys(jsonData.editors).forEach(function (key) {
                                var cacheKey = params.nodeId + "_" + key.toLowerCase();
                                XPortal.GridInlineEditing._editorsCache[cacheKey] = jsonData.editors[key] && jsonData.editors[key].trim ? jsonData.editors[key].trim() : jsonData.editors[key];
                            });
                        }
                        if (jsonData.columnValidators) {
                            Object.keys(jsonData.columnValidators).forEach(function (key) {
                                var cacheKey = params.nodeId + "_" + key.toLowerCase();
                                XPortal.GridInlineEditing._columnValidatorsCache[cacheKey] = jsonData.columnValidators[key] && jsonData.columnValidators[key].trim ? jsonData.columnValidators[key].trim() : jsonData.columnValidators[key];
                            });
                        }
                    }
                },
                error: function (jqXHR, textStatus, errorThrown) {
                    if (console) console.error(params, jqXHR, textStatus, errorThrown);
                }
            });
            $.when(ajaxReq, XPortal.DatePicker.EnsureLocalization()).then(function () {
                d.resolve();
            }, d.reject);
            return d.promise();
        },
        IsColumnEditable: function (model) {
            if (XPortal.GridInlineEditing._isInChangeEditProcess) return false;
            if (this.column.field === "selectable") return false;
            this.modelName = this.modelName || (XPortal.Grid.GetGridInfo(this.grid) || {}).modelName;
            let pModl = this.prMdlName ? XPortal.Store.GetModelByName(this.prMdlName).model || {} : null;
            if (pModl == null) {
                pModl = (XPortal.Grid.GetModelParentModel(this.modelName) || {}).model || {};
                this.prMdlName = pModl.modelName;
            }
            if (pModl && pModl.isViewMode && pModl.isViewModeInheritedOnChild) return false;

            const editableColumn = (this.editable && typeof this.column.editor !== typeof undefined) || (this.creatable && model._newInlineRecord);

            return !!editableColumn;
        },
        SetupEditorValidationRules: function (editor, options, modelName) {
            try {
                if (console) console.debug("SetupEditorValidationRules(...)");

                var validatorContainer = $("<form novalidate='novalidate' style='display:none;' class='grid-cell-validation-form'></form>");
                $(validatorContainer).appendTo(editor);
                validatorContainer.data("modelName", modelName);
                XPortal.Validation.ParseElementsIn(editor, validatorContainer);
            }
            catch (e) {
                if (console) console.error(e);
            }
        },
        GetCellEditorControl: function (container, fieldName) {
            var aSelect = container.find("select[data-metadata-fieldname]:first");
            if (aSelect.length > 0) return aSelect;
            return container.find(":input[data-editor]:first");
        },
        ValidateGridModel: function (modelName) {
            return XPortal.Store.ValidateGridModel(modelName);
        },
        ValidateAllGridModels: function () {
            if (self.changesAlreadyRejected) {
                return true;
            }

            var state = XPortal.Store.GetBaseReduserState();
            var result = true;
            for (var key in state.pageModels) {
                if (key.startsWith("GM.") && state.pageModels.hasOwnProperty(key)) {
                    var validationResult = XPortal.Store.ValidateGridModel(key);
                    if (!result || !validationResult) {
                        result = false;
                    }
                }
            }
            return result;
        },
        DateTimeFieldProcessing: function (dataModel) {
            if (!dataModel || !dataModel.Fields) return dataModel;
            var lengthFields = dataModel.Fields.length;
            for (var index = 0; index < lengthFields; index++) {
                if (['datetime'].includes((dataModel.Fields[index][(dataModel.Fields[index].ftype ? "ftype" : "Ftype")] && dataModel.Fields[index][(dataModel.Fields[index].ftype ? "ftype" : "Ftype")].toLowerCase()))) {
                    var objData = dataModel.Fields[index][(dataModel.Fields[index].data ? "data" : "Data")];
                    if (!objData) continue;
                    let strModel = XPortal.Store.GetState().pageModels[XPortal.Store.GetModelByNodeId(dataModel.NodeId)];
                    if (!strModel) continue;
                    var storedData = strModel.itemsToSave ?
                        strModel.itemsToSave[0].entity.Fields.filter(f => f.Name == dataModel.Fields[index].field || f.Name == dataModel.Fields[index].Field) :
                        strModel.entity.Fields.filter(f => f.Name == dataModel.Fields[index].Field || f.Name == dataModel.Fields[index].field);
                    var tmpVal = processedDT = objData.toString();
                    if (objData != '') {
                        var storedChanged = (storedData && storedData.length > 0 && storedData[0].IsChanged);
                        if (strModel.GridModel) processedDT = storedChanged ? XPortal.Utils.AdjustDT(new Date(objData), false) : processedDT;
                        else {
                            const dateProcRes = new Date(objData);
                            if (isNaN(dateProcRes)) {
                                continue;
                            }
                            processedDT = !storedChanged ? processedDT : XPortal.Utils.AdjustDT(dateProcRes, false);
                        }


                        dataModel.Fields[index][(dataModel.Fields[index].data ? "data" : "Data")] = XPortal.Utils.TransformDateTime(processedDT, null, true, false, true, true).toISOString();
                        if (console) console.log("DateTimeFieldProcessing changed From:" + tmpVal + " To:" + dataModel.Fields[index][(dataModel.Fields[index].data ? "data" : "Data")]);
                    }
                }
            }
            return dataModel;
        },
    };
    function applyEditModeState(grid, button, command, options) {
        XPortal.GridActions.actionmodels[grid.getKendoGrid().options.pageData.nodeId].set("inlinedisabled", !options.editable);
        if (!command) return;
        $(button).html('');
        $(button).append(options.editable ? command.disableIcon : command.enableIcon);
        const title = options.editable ? command.disableTitle : command.enableTitle;
        $(button).attr("title", title);
        $(button).append(XPortal.GridInlineEditing.WrapTitle(title));
    };
    function getInEditorByKey(key) {
        if (XPortal.GridInlineEditing._editorsLoader) {
            XPortal.GridInlineEditing._editorsLoader.then(function () {
                delete XPortal.GridInlineEditing._editorsLoader;
                if (XPortal.GridInlineEditing._editorsCache[key]) {
                    return XPortal.GridInlineEditing._editorsCache[key];
                }
            });
        }
        if (self._editorsCache[key]) {
            return self._editorsCache[key];
        }
    };
    function getEntityProfileInfo(url, m) {
        if (!m || !m.model) return url;
        const curl = new URL(window.location.href);
        const u = new URL(url, curl.origin);
        if (u.searchParams.get("pfs") || "") return url;
        const ourl = new URL(url, curl.origin);

        let uid = XPortal.Template.GetObjPropValueByName(m.model, "uniqueId");
        if (uid && uid.length > 8) uid = uid.substring(0, 8);
        var pfsval = "" + XPortal.Template.GetObjPropValueByName(m.model, "nodeId") + "/" + XPortal.Template.GetObjPropValueByName(m.model, "entityAlias") + "/" + uid;

        ourl.searchParams.set("pfs", pfsval);
        return ourl.toString();
    };
    return self;
}());